import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const loginGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.renewIfExpiringSoon();

  if (authService.isLoggedIn() && !(await authService.isTokenExpired())) {
    router.navigate([authService.getDefaultFeatureRoute()]);
    return false;
  }
  return true;
};